import * as Phaser from "phaser-ce"
import { TextUtils } from "../../common/TextUtils"
import { PhaserUtils } from "../utils/PhaserUtils"
import { ProgressBar } from "../utils/ProgressBar"
import { ButtonSize, ButtonType } from "./Buttons"

export enum GenericAssets {
    SCIENTIST = "GenericSCIENTIST",
    CIGARETTE = "GenericCIGARETTE",
    NEXT_BUTTON = "GenericNEXT_BUTTON",
    TOGGLE_BUTTON = "GenericTOGGLE_BUTTON",
    VAPE_SMOKE = "GenericVAPE_SMOKE",
    VAPE_SMOKE_REVERSED = "GenericVAPE_SMOKE_REVERSED",
    SMOKE = "GenericSMOKE",
    MOUTH_POSITIONS = "GenericMOUTH_POSITIONS",
    BUTTON = "GenericBUTTON",

    // Fancy buttons
    PRIMARY_BUTTON = "GenericPRIMARY_BUTTON",
    LISTEN_BUTTON = "GenericLISTEN_BUTTON",
    SECONDARY_BUTTON = "GenericSECONDARY_BUTTON",
    GHOST_BUTTON = "GenericGHOST_BUTTON",

    TEXT_BOX = "GenericTEXT_BOX",
    WHITE_BAR = "GenericWHITE_BAR",
    WHITE_BAR_LEFT = "GenericWHITE_BAR_LEFT",
    ECIG = "GenericECIG",
    ECIG_CROPPED = "GenericECIG_CROPPED",
    PROJECTOR = "GenericPROJECTOR",
    BULLET = "GenericBULLET",
    SMALL_BULLET = "GenericSMALL_BULLET",

    BLACK_PIXEL = "GenericBLACK_PIXEL",
    WHITE_PIXEL = "GenericWHITE_PIXEL",

    BELL_SOUND = "GenericBELL_SOUND",
    BUZZER = "GenericBUZZER",

    JUUL = "GenericJUUL",
    MODPOD = "GenericMODPOD",

    SPEECH_BUBBLE = "GenericSPEECH_BUBBLE"
}

export const buttonAsset = (type: ButtonType = ButtonType.PRIMARY, size: ButtonSize = ButtonSize.NORMAL) => {
    let sizeString = ""
    if (size !== ButtonSize.NORMAL) {
        sizeString = "_" + size
    }
    return `Generic${type}_BUTTON${sizeString}`
}

export function loadGenericAssets(game: Phaser.Game) {
    
    const load = PhaserUtils.makeLoader(game, "generic")
    
    load.spritesheet(GenericAssets.CIGARETTE, "lit-cig.png", 153, 277)
    load.spritesheet(GenericAssets.NEXT_BUTTON, "next-button.png", 200, 49)
    load.spritesheet(GenericAssets.TOGGLE_BUTTON, "toggle-button.png", 120, 40)
    load.spritesheet(GenericAssets.VAPE_SMOKE, "vape-smoke.png", 250, 234)
    load.spritesheet(GenericAssets.VAPE_SMOKE_REVERSED, "vape-smoke-reversed.png", 250, 234)
    load.spritesheet(GenericAssets.SMOKE, "smoke.png", 180, 195)
    load.spritesheet(GenericAssets.MOUTH_POSITIONS, "mouth-positions.png", 34, 18)
    load.spritesheet(GenericAssets.BUTTON, "button.png", 181, 51)
    load.spritesheet(GenericAssets.LISTEN_BUTTON, "listen-button.png", 40, 40)

    const buttons = [GenericAssets.PRIMARY_BUTTON, GenericAssets.SECONDARY_BUTTON, GenericAssets.GHOST_BUTTON]

    buttons.forEach(button => {
        const buttonName = button.replace("Generic", "").replace("_", "-").toLowerCase()
        // log.debug(`Loading button sprite with name ${buttonName}`)
        load.spritesheet(button, `${buttonName}.png`, 120, 40)
        load.spritesheet(`${button}_SQUARE`, `${buttonName}-square.png`, 40, 40)
        load.spritesheet(`${button}_WIDE`, `${buttonName}-wide.png`, 160, 40)
        load.spritesheet(`${button}_EXTRA_WIDE`, `${buttonName}-extra-wide.png`, 200, 40)
    })

    load.image(GenericAssets.SCIENTIST, "scientist.png")
    load.image(GenericAssets.TEXT_BOX, "text-box.png")
    load.image(GenericAssets.WHITE_BAR, "white-bar.png")
    load.image(GenericAssets.WHITE_BAR_LEFT, "white-bar-left.png")
    load.image(GenericAssets.ECIG, "ecig.png")
    load.image(GenericAssets.ECIG_CROPPED, "ecig-cropped.png")
    load.image(GenericAssets.PROJECTOR, "projector.png")
    load.image(GenericAssets.BLACK_PIXEL, "black-pixel.png")
    load.image(GenericAssets.WHITE_PIXEL, "white-pixel.png")
    load.image(GenericAssets.BULLET, "bullet.png")
    load.image(GenericAssets.SMALL_BULLET, "small-bullet.png")
    load.image(GenericAssets.JUUL, "juul.png")
    load.image(GenericAssets.MODPOD, "modpod.png")
    load.image(GenericAssets.SPEECH_BUBBLE, "speech-bubble-rect.png")

    load.audio(GenericAssets.BELL_SOUND, "bell.wav")
    load.audio(GenericAssets.BUZZER, "buzzer.wav")

    TextUtils.loadFonts()

    ProgressBar.start(game)
}

